export default __webpack_public_path__ + "static/soundly-back-dafb8a6dfa349cc77f6acd48ee940e40.webp";